import { Bluesky } from '@sparemin/blockhead';
import React from 'react';
import SocialCircle from './SocialCircle';

export interface BlueskySocialCircleProps {
  width?: string;
  height?: string;
  color?: string;
  className?: string;
}

const BlueskySocialCircle: React.FC<BlueskySocialCircleProps> = ({
  width,
  height,
  color,
  className,
}) => (
  <SocialCircle background="white" className={className}>
    <Bluesky {...{ width, height, color }} />
  </SocialCircle>
);

export default BlueskySocialCircle;
